// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCreateSiteRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentCreateSiteRequestModel.attributeTypeMap;
    }
}
EnrollmentCreateSiteRequestModel.discriminator = undefined;
EnrollmentCreateSiteRequestModel.additionalProperties = false;
EnrollmentCreateSiteRequestModel.attributeTypeMap = [
    {
        "name": "siteVerified",
        "baseName": "siteVerified",
        "type": "boolean"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<EnrollmentPhoneNumberModel>"
    },
    {
        "name": "address1",
        "baseName": "address1",
        "type": "string"
    },
    {
        "name": "address2",
        "baseName": "address2",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "country",
        "baseName": "country",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "postalCode",
        "baseName": "postalCode",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
    {
        "name": "communicationTypes",
        "baseName": "communicationTypes",
        "type": "Array<TCSCommunicationType>"
    },
    {
        "name": "communicationOption",
        "baseName": "communicationOption",
        "type": "TCSCommunicationOption"
    },
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "TCSSource"
    },
];
//# sourceMappingURL=enrollmentCreateSiteRequestModel.js.map